// src/pages/AdminList.jsx
import { useEffect, useState } from "react";
import axios from "axios";
import "./page.css";

const API_URL = "https://irc.zentelex.com/api/admin";

const AdminList = ({ onClickButton }) => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  // Filter states
  const [userTypeFilter, setUserTypeFilter] = useState("");
  const [searchFilter, setSearchFilter] = useState("");

  useEffect(() => {
    fetchAdmins();
  }, [onClickButton]);

  const fetchAdmins = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${API_URL}/admins`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdmins(res.data.data);
    } catch (error) {
      console.error("Failed to fetch admins", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this admin?"
    );
    if (!confirmDelete) return;

    try {
      setDeletingId(id);
      const token = sessionStorage.getItem("token");

      await axios.delete(`${API_URL}/admins/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAdmins((prev) => prev.filter((admin) => admin.id !== id));
    } catch (error) {
      console.error("Delete failed", error);
      alert("Failed to delete admin");
    } finally {
      setDeletingId(null);
    }
  };

  // Filtered admins
  const filteredAdmins = admins.filter((admin) => {
    const matchesType = userTypeFilter
      ? admin.user_type === userTypeFilter
      : true;
    const matchesSearch = searchFilter
      ? admin.name.toLowerCase().includes(searchFilter.toLowerCase()) ||
        admin.email.toLowerCase().includes(searchFilter.toLowerCase())
      : true;
    return matchesType && matchesSearch;
  });

  if (loading) return <div className="loader">Loading admins...</div>;

  return (
    <div className="admin-container">
      <h2 className="page-title">Admin Management</h2>

      {/* Filters */}
      <div className="filters">
        <select
          className="filter-select"
          value={userTypeFilter}
          onChange={(e) => setUserTypeFilter(e.target.value)}
        >
          <option value="">All User Types</option>
          <option value="SuperAdmin">SuperAdmin</option>
          <option value="Admin">Admin</option>
        </select>

        <input
          type="text"
          className="filter-input"
          placeholder="Search by name or email"
          value={searchFilter}
          onChange={(e) => setSearchFilter(e.target.value)}
        />

        <button
          className="clear-filters"
          onClick={() => {
            setUserTypeFilter("");
            setSearchFilter("");
          }}
        >
          Clear
        </button>
      </div>

      <div className="table-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredAdmins.map((admin, index) => (
              <tr key={admin.id}>
                <td>{index + 1}</td>
                <td className="name-cell">{admin.name}</td>
                <td>{admin.email}</td>
                <td>
                  <span className={`badge ${admin.role.toLowerCase()}`}>
                    {admin.role}
                  </span>
                </td>
                <td>{new Date(admin.createdAt).toLocaleDateString("en-IN")}</td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(admin.id)}
                    disabled={deletingId === admin.id}
                  >
                    {deletingId === admin.id ? "Deleting..." : "Delete"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filteredAdmins.length === 0 && (
          <div className="empty-state">No admins found</div>
        )}
      </div>
    </div>
  );
};

export default AdminList;
